import {FiGlobe} from "react-icons/fi";

import UILinkButton from "./UILinkButton";

/**
 * Network Link Button that navigates to the root path ("/") when clicked.
 */
const NetworkLinkButton = () => {
  return (
    <UILinkButton to="/" title="Network View" icon=<FiGlobe/> />
  );
};
export default NetworkLinkButton;